// src/theme/index.js
import { createTheme } from '@mui/material/styles';
import { lighten } from "@mui/system";

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: "#00796B", // Rich teal
      main1: '#008080',        // Teal base
      light: '#4DB6AC',
      dark: '#00675B',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FFC107',         // Warm accent
      contrastText: '#000',
    },
    background: {
      default: "#f9fafb", // Soft gray background
      default1: '#F9FAFB',      // Light background
      paper: '#FFFFFF',
    },
    text: {
      primary: "#2c3e50", // Dark neutral
      primary1: '#1A1A1A',
      secondary: '#4B4B4B',
    },
    success: {
      main: '#4CAF50',
    },
    warning: {
      main: '#FFA726',
    },
    error: {
      main: '#F44336',
    },
    info: {
      main: '#29B6F6',
    },
    custom: {
      main: '#008080', // For consistency in component styles
    },
    action: {
      hover1: lighten("#008080", 0.4), // your desired hover background color
      hover: "#e0f2f1", // Light teal
    },
  },

  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica Neue', sans-serif",
    h1: {
      fontSize: '3rem',
      fontWeight: 700,
      color: '#008080',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 700,
      color: '#008080',
    },
    h4: {
      fontWeight: 600,
      color: '#008080',
    },
    h6: {
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.9rem',
      lineHeight: 1.5,
      color: '#4B4B4B',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },

  shape: {
    borderRadius: 0, // softer UI
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
  },
});

export default theme;
